import getters from "@/store/modules/meeting/getters";
import actions from "@/store/modules/meeting/actions";
import mutations from "@/store/modules/meeting/mutations";
import { LAYOUT_TYPE } from "@/resources/constants/meeting";
const state = {
  usersInCall: [],
  openDevicesConfig: false,
  openBackgroundImages: false,
  cameraEnabled: true,
  shareScreenEnabled: false,
  micEnabled: true,
  columnDisplay: true,
  layoutType: LAYOUT_TYPE.GRID,
  activeParticipant: null,

  selectedAudioInput: null,
  selectedVideoInput: null,
  selectedAudioOutput: null,

  attendee: null,
  meeting: null,
  meetingSession: null,
  videoUrl: null,
  isFirstConnection: false,

  meetingType: null,
  isVideoUrlLockedByAdmin: false,
  openWebinarUrl: { active: false, idRoom: 0 },
  openMeetingrUrl: false,
  roomIdWebinarUpdate: 0,
  webinarActive: false,
  roomId: 0,
  backgroundProcessors: [],
  backgroundIsSupported: false,
  backgroundImage: localStorage.getItem("background_image") || "",
  backgroundEnabled: localStorage.getItem("background_enabled") === "true",
  blurEnabled: localStorage.getItem("blur_enabled") === "true",
  blurAmount: parseInt(localStorage.getItem("blur_amount") || "0"),
  blurProcessors: [],
  transformDevice: null,
  blurIsSupported: false,
  voiceTransformDevice: null,
  voiceIsEnabled: localStorage.getItem("voice_enabled") === "true",
  voiceIsSupported: false,
  pressToTalkEnabled: false,
  callIsRecord: false,
  activeGame: false,
  roomName: "",
  showCallModal: false,
  showCallFromSpaceUser: 0,

  countPlayerInCall: 1,
  focusMode: false,
  roomAutoVideoId: null,
};
export type State = typeof state;

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
